export default {
    name: 'Facebook',
    dimensions: { width: 40, height: 40 },
    content: `<path fill="currentColor" stroke="none" d="M20 0C8.95423 0 0 8.95423 0 20C0 29.9827 7.31394 38.2569 16.8753 39.7571V25.7826H11.7959V20H16.8753V15.5928C16.8753 10.5781 19.8623 7.8106 24.4298 7.8106C26.618 7.8106 28.9073 8.20148 28.9073 8.20148V13.1235H26.3845C23.8983 13.1235 23.1247 14.6677 23.1247 16.2482V20.0003H28.6712L27.7851 25.7829H23.1247V39.7574C32.6861 38.2572 40 29.983 40 20.0003C40 8.95423 31.0458 0 20 0Z"/>`
};
